import getTrackerCategory from './getTrackerCategory.js';
import trackerMatches from './trackerMatches.js';
const getTrackerInfo = (trackerId, config) => {
  const trackingCategory = getTrackerCategory(trackerId, config);
  return trackingCategory?.trackers.find(tracker => trackerMatches(tracker, trackerId));
};
export { getTrackerInfo as default };
//# sourceMappingURL=getTrackerInfo.js.map
